import { render } from "./BecomeACreatorStats.vue?vue&type=template&id=3d9f9596"
import script from "./BecomeACreatorStats.vue?vue&type=script&lang=js"
export * from "./BecomeACreatorStats.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__